import { render, staticRenderFns } from "./SendAnnounceDetail.vue?vue&type=template&id=3f2b35ac&scoped=true&"
import script from "./SendAnnounceDetail.vue?vue&type=script&lang=js&"
export * from "./SendAnnounceDetail.vue?vue&type=script&lang=js&"
import style0 from "./SendAnnounceDetail.vue?vue&type=style&index=0&id=3f2b35ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b35ac",
  null
  
)

export default component.exports